import { Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import Panel from './Panel';
import PanelTitle from './PanelTitle';

/** The calendar's explanation of what a day's percentage means. */
export default function HowToRead({ capacityPerDay }) {
  return (
    <Panel sx={{ p: 2.5 }}>
      <PanelTitle title="How to read a day" />
      <Typography sx={{ mt: 1, fontSize: 12.5, lineHeight: 1.6, color: WD.inkMuted }}>
        The percentage is the whole team&apos;s hours against capacity ({capacityPerDay}h per person per working day). Past days count
        time actually logged; today and later count the planned hours still left, spread over the working days up to each task&apos;s due
        date. The tags count people over 100% and under 50% that day. Tasks on hold are paused and add nothing.
      </Typography>
    </Panel>
  );
}
